import type { EnumUnion } from '@dresscode-frontend/utility-types';
import { z } from 'zod';
import { DeviceGenre } from '@/constants/device';
import { OrderDirection } from '@/constants/orderDirection';

// カラム名定数
export const Columns = {
  NAME: 'NAME',
  TYPE: 'TYPE',
  GENRE: 'GENRE',
  MANUFACTURER: 'MANUFACTURER',
  STATUS: 'STATUS',
  ACTIVATED_DATE: 'ACTIVATED_DATE',
  LAST_MODIFIED_DATE: 'LAST_MODIFIED_DATE',
  ARCHIVED_DATE: 'ARCHIVED_DATE',
  CATALOG_CODE: 'CATALOG_CODE'
} as const;
export type Columns = EnumUnion<typeof Columns>;

// ソート対象の項目
const OrderBy = {
  NAME: 'NAME',
  ACTIVATED_DATE: 'ACTIVATED_DATE',
  LAST_MODIFIED_DATE: 'LAST_MODIFIED_DATE',
  ARCHIVED_DATE: 'ARCHIVED_DATE'
} as const;

// カタログステータスフィルタ
export const CatalogStatusFilterKey = {
  ACTIVE: 'ACTIVE',
  DRAFT: 'DRAFT',
  ARCHIVED: 'ARCHIVED',
  ALL: 'ALL'
} as const;
export type CatalogStatusFilterKey = EnumUnion<typeof CatalogStatusFilterKey>;

// 検索パラメータのZodスキーマ
export const SearchSchema = z.object({
  pageIndex: z.number().default(0),
  pageSize: z.number().default(100),
  freeText: z.string().optional(),
  sortColumn: z.nativeEnum(OrderBy).optional(),
  sortOrder: z.nativeEnum(OrderDirection).optional(),
  status: z.nativeEnum(CatalogStatusFilterKey).default(CatalogStatusFilterKey.ALL),
  genre: z.nativeEnum(DeviceGenre).optional()
});